// ELVA's work — pure helpers.
export const EW_PRACTICE = 'Alamo Heights Dental';
export const EW_ACTOR = { name: 'Ava Thompson', org: 'Lone Star Billing' } as const;
export const EW_TODAY = 'Oct 15';

export function money(n: number): string {
  return `$${n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function hoursLabel(h: number): string {
  return `${h.toLocaleString('en-US', { maximumFractionDigits: 1 })} h`;
}

export function mmss(totalSec: number): string {
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m)}:${String(s).padStart(2, '0')}`;
}

export function csvEscape(v: string): string {
  return /[",\n]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v;
}
